
// 插件路由
const dianxiaotuan = () => import(/* webpackChunkName: "addon" */ '~/addon/dianxiaotuan/pages/dianxiaotuan.vue')

const routes = [
	{ 
        path: '/dianxiaotuan', 
        component: dianxiaotuan 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/dianxiaotuan/router/index.js